export default [
  {
    path: "/jn9Wvgfy/:fre?",
    name: "outstanding",
    meta: {
      title: "Oustanding",
      authRequired: true,
      acc: ["y15290"],
    },
    component: () => import("@/views/invoice/outstanding.vue"),
  },
  {
    path: "/Bjjhkw",
    name: "payment",
    meta: {
      title: "Payment",
      authRequired: true,
      acc: "y24834",
    },
    component: () => import("@/views/invoice/invoice-item.vue"),
  },

  {
    path: "/w2wMqZ/:reff?",
    name: "checkout",
    meta: {
      title: "Checkout",
      authRequired: true,
      acc: "y63939",
    },
    component: () => import("@/views/invoice/payment-invoice.vue"),
  },
  {
    path: "/view-payment/:id",
    name: "view-payment",
    component: () => import("@/views/school/components/payment.vue"),
    meta: {
      title: "PAYMENT",
      authRequired: true,
      acc: "y63939",
    },
  },
  {
    path: "/UDIh7y",
    name: "paymentstatus",
    meta: {
      title: "Confirm Payment",
      authRequired: true,
      acc: 'y63939'
    },
    component: () => import("@/views/payments/confirm.vue"),
  },
];
